import { render, staticRenderFns } from "./OpinionHotWords.vue?vue&type=template&id=019c9244"
import script from "./OpinionHotWords.vue?vue&type=script&lang=js"
export * from "./OpinionHotWords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports